/**
 * Same-origin, resized copy of a remote image served by the Next.js image optimizer.
 * WebGL textures need same-origin pixels, so shaders load their textures through this.
 */
export const optimizedImageUrl = (src: string, width = 1920, quality = 92): string =>
    `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`
